import { MarisolNumberedCard } from "./MarisolNumberedCard.component.tsx";

export default MarisolNumberedCard;
